import CropFreeIcon from '@mui/icons-material/CropFree';
import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComVotoNaoRegistrado extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação com pelo menos 1 voto ausente (não registrado)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return !registro.votos || registro.votos.findIndex((voto) => !voto.voto?.codigo) !== -1;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
